import React, { useState, useEffect } from 'react';
import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';
import SvgIcon from '../../SvgIcon/SvgIcon';
import { useInventoryStock } from '../../../hooks/inventory/useInventoryStock';

const EditStockSettingsModal: React.FC = () => {
  const {
    isEditModalOpen,
    selectedStock,
    handlerUpdateStockSettings,
    handlerCloseEditModal,
  } = useInventoryStock();

  const [minStock, setMinStock] = useState<number | ''>('');
  const [reorderPoint, setReorderPoint] = useState<number | ''>('');
  const [errors, setErrors] = useState<{
    minStock?: string;
    reorderPoint?: string;
  }>({});

  useEffect(() => {
    if (isEditModalOpen && selectedStock) {
      setMinStock(selectedStock.minStock > 0 ? selectedStock.minStock : '');
      setReorderPoint(
        selectedStock.reorderPoint > 0 ? selectedStock.reorderPoint : ''
      );
      setErrors({});
    }
  }, [isEditModalOpen, selectedStock]);

  const handleSave = async () => {
    const newErrors: { minStock?: string; reorderPoint?: string } = {};

    if (minStock === '' || minStock < 0) {
      newErrors.minStock = 'Debe ingresar un stock mínimo válido';
    }

    if (reorderPoint === '' || reorderPoint < 0) {
      newErrors.reorderPoint = 'Debe ingresar un punto de reorden válido';
    }

    if (!selectedStock) {
      console.error('❌ No hay producto seleccionado para actualizar.');
      return;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    await handlerUpdateStockSettings({
      productId: selectedStock.productId,
      branchId: selectedStock.branchId,
      minStock: Number(minStock),
      reorderPoint: Number(reorderPoint),
    });

    handlerCloseEditModal();
  };

  if (!selectedStock) return null; // Seguridad

  return (
    <FormModal
      isOpen={isEditModalOpen}
      onClose={handlerCloseEditModal}
      title="Actualizar Stock Mínimo y Punto de Reorden"
      maxWidth="max-w-3xl"
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {/* Datos en solo lectura */}
        <InputField
          label="Producto"
          name="productName"
          type="text"
          iconKey="product"
          value={selectedStock.productName}
          disabled
        />

        <InputField
          label="Sucursal"
          name="branchName"
          type="text"
          iconKey="branch"
          value={selectedStock.branchName}
          disabled
        />

        <InputField
          label="Stock Actual"
          name="stockQuantity"
          type="number"
          iconKey="product"
          value={selectedStock.stockQuantity}
          disabled
        />

        <InputField
          label="Costo Promedio"
          name="averageCost"
          type="number"
          iconKey="dollar"
          value={selectedStock.averageCost}
          disabled
        />

        {/* Campos editables */}
        <InputField
          label="Stock Mínimo"
          name="minStock"
          type="number"
          iconKey="product"
          value={minStock}
          onChange={(e) =>
            setMinStock(e.target.value === '' ? '' : Number(e.target.value))
          }
          min={0}
          required
          error={errors.minStock}
        />

        <InputField
          label="Punto de Reorden"
          name="reorderPoint"
          type="number"
          iconKey="product"
          value={reorderPoint}
          onChange={(e) =>
            setReorderPoint(e.target.value === '' ? '' : Number(e.target.value))
          }
          min={0}
          required
          error={errors.reorderPoint}
        />
      </div>

      <div className="mt-6 flex justify-end">
        <button
          type="button"
          onClick={handleSave}
          className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90"
        >
          <SvgIcon name="save" />
          Actualizar Stock
        </button>
      </div>
    </FormModal>
  );
};

export default EditStockSettingsModal;
